import { formatTime, zoned } from "../../lib/time.ts";

export const HQ_TIMEZONE = "Europe/Stockholm";

export function localised(text: Record<string, string>, locale: string): string {
  return text[locale] ?? text.sv ?? "";
}

export function formatInstant(iso: string, timezone: string): string {
  const when = zoned(iso, timezone);
  return `${when.toPlainDate().toString()} ${formatTime(when)}`;
}
